// extracted by mini-css-extract-plugin
export default {"paragraphText":"ParagraphText_paragraphText__UgvYt"};